import { render } from "./MenuChildren.vue?vue&type=template&id=af2854c0&scoped=true"
import script from "./MenuChildren.vue?vue&type=script&lang=js"
export * from "./MenuChildren.vue?vue&type=script&lang=js"

import "./MenuChildren.vue?vue&type=style&index=0&id=af2854c0&lang=scss&scoped=true"

import exportComponent from "/data/devops/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af2854c0"]])

export default __exports__